module.exports = __webpack_public_path__ + "static/media/sensable_12.af20b29e.gif";